import { render, staticRenderFns } from "./TraxAccountGroupEditCandidates.vue?vue&type=template&id=6c602fe5"
import script from "./TraxAccountGroupEditCandidates.vue?vue&type=script&lang=js"
export * from "./TraxAccountGroupEditCandidates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports